'use client';

import * as Sentry from '@sentry/nextjs';
import Error from 'next/error';
import { useEffect } from 'react';
import './globals.css';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    try {
      Sentry.captureException(error);
    } catch (error) {
      console.error('Sentry initialization failed:', error);
    }
  }, [error]);

  return (
    <html lang="en">
      <head>
        <link rel="icon" href="/svg/logo_round.svg" sizes="any" />
      </head>
      <body className={`h-full`}>
        <div className="mx-auto flex flex-col">
          <Error statusCode={500} />
        </div>
      </body>
    </html>
  );
}
